import React from 'react'
import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import MapComponent from '../../../modules/map/MapComponent'
import InputTextarea from '../../views/widgets/InputTextarea';

const GeneralInfoLocationForm = ({
  language,
  values,
  errors,
  onBlur,
  handleChange,
  onMarkerChange,
}) => (
  <div className="columns">
    <div className="column">
      <Field label="Latitude">
        <InputText
          name={`latitude`}
          type="number"
          placeholder="Enter your Latitude"
          onChange={handleChange}
          onBlur={onBlur}
          value={values.latitude}
        />
      </Field>
      <Field label="Longitude">
        <InputText
          name={`longitude`}
          type="number"
          placeholder="Enter your Longitude"
          onChange={handleChange}
          onBlur={onBlur}
          value={values.longitude}
        />
      </Field>
      <Field label="Street Address">
        <InputTextarea
          name={`streetAddress.${language}`}
          placeholder="Enter your street Address"
          onChange={handleChange}
          onBlur={onBlur}
          value={values.streetAddress[language]}
        />
      </Field>
    </div>
    <div className="column">
      <MapComponent
        isMarkerShown
        onMarkerChange={onMarkerChange}
        defaultCenter={{ lat: values.latitude, lng: values.longitude }}
        markers={[
          { position: { lat: values.latitude, lng: values.longitude } },
        ]}
      />
    </div>
  </div>
)

export default GeneralInfoLocationForm



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoFormLocation.js